import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PROJECT_MANAGEMENT_URL } from '@insite-store360/shared';
import { Observable, catchError } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';

export interface ApprovalRequirementItem {
    id?: number;
    countryId: number;
    countryName: string;
    isApprovalNotRequired: boolean;
    createdDateTime?: Date;
    updatedDateTime?: Date;
}

@Injectable({
    providedIn: 'root',
})
export class ApprovalRequirementService {
    private readonly URL_PATH = `${PROJECT_MANAGEMENT_URL}/approval-requirement`;

    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    public getAll(
        pageIndex?: number,
        pageSize?: number,
        searchValue?: string,
        countryIds?: number[]
    ): Observable<{ data: ApprovalRequirementItem[]; paginatorValue: { totalData: number; totalCount: number } }> {
        let params = new HttpParams();
        if (pageIndex !== undefined && pageIndex !== null) {
            params = params.set('pageIndex', pageIndex.toString()); // backend already 1-based
        }
        if (pageSize !== undefined && pageSize !== null) {
            params = params.set('pageSize', pageSize.toString());
        }
        if (searchValue && searchValue.trim() !== '') {
            params = params.set('searchValue', searchValue.trim());
        }
        if (countryIds && countryIds.length > 0) {
            params = params.set('countryIds', countryIds.join(','));
        }
        return this.http
            .get<{ data: ApprovalRequirementItem[]; paginatorValue: { totalData: number; totalCount: number } }>(`${this.URL_PATH}/get-all`, { params })
            .pipe(catchError(this.errorHandler.handleError));
    }

    public save(
        countryId: number,
        isApprovalNotRequired: boolean,
        userId: number
    ): Observable<{ message: string; result: ApprovalRequirementItem }> {
        return this.http
            .post<{ message: string; result: ApprovalRequirementItem }>(`${this.URL_PATH}/save`, { countryId, isApprovalNotRequired, userId })
            .pipe(catchError(this.errorHandler.handleError));
    }

    public delete(id: number, userId: number): Observable<{ message: string }> {
        return this.http
            .delete<{ message: string }>(`${this.URL_PATH}/delete/${id}`, { body: { userId } })
            .pipe(catchError(this.errorHandler.handleError));
    }
}
